<template>
    <div id="picture-detail">
        <transition :name="currentTransition">
            <div class="image-view" :key="pictureDetail">
                <div class="image-wrapper">
                    <div class="back" @click="back()">&times;</div>
                    <img :src="currentImage" />
                </div>
            </div>
        </transition>
        <div class="pagination">
            <span class="arrow arrow-left"
                  v-show="hasPrev"
                  @click="prev()"
            ></span>
            <span class="back" @click="back()">Powrót</span>
            <span class="arrow arrow-right"
                  v-show="hasNext"
                  @click="next()"
            ></span>
        </div>
    </div>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
    @import 'css/colors';

    #picture-detail {
        .image-view {
            position: relative;
            height: 400px;
            display: flex;
            align-items: center;
            justify-content: center;

            .image-wrapper {
                display: inline-block;
                position: relative;

                img {
                    user-select: none;
                    max-width: 100%;
                    max-height: 400px;
                }

                .back {
                    $radius: 11px;
                    position: absolute;
                    right: -$radius;
                    top: -$radius;

                    display: inline-block;
                    width: 2 * $radius;
                    height: 2 * $radius;
                    border-radius: 12px;
                    line-height: 2 * $radius - 2px;

                    cursor: pointer;
                    font-size: 18px;

                    background-color: $blue;
                }
            }
        }

        // Transitions
        .slide-right-enter-active {
            top: 0;
            position: absolute;
            width: 100%;
        }

        .slide-right-leave-active {
            top: 0;
            position: absolute;
            width: 100%;
        }

        .slide-left-enter-active {
            top: 0;
            position: absolute;
            width: 100%;
        }

        .slide-left-leave-active {
            top: 0;
            position: absolute;
            width: 100%;
        }
    }
</style>

<script>
    export default {
        name: 'PictureDetail',
        props: {
            _pictureDetail: {
                type: Number,
                required: true,
            },
            picturesList: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                pictureDetail: this._pictureDetail,
                currentTransition: 'slide-right',
            };
        },
        computed: {
            currentImage() {
                return this.picturesList[this.pictureDetail].image;
            },
            currentPage() {
                return this.pictureDetail + 1;
            },
            lastPage() {
                return this.picturesList.length;
            },
            hasPrev() {
                return this.currentPage > 1;
            },
            hasNext() {
                return this.currentPage < this.lastPage;
            },
        },
        methods: {
            next() {
                if (this.hasNext) {
                    this.currentTransition = 'slide-right';
                    this.pictureDetail += 1;
                }
            },
            prev() {
                if (this.hasPrev) {
                    this.currentTransition = 'slide-left';
                    this.pictureDetail -= 1;
                }
            },
            back() {
                this.$emit('reset');
            },
        },
    };
</script>



// WEBPACK FOOTER //
// PictureDetail.vue?efaa2a96